import { render, staticRenderFns } from "./DioptraModalProductCard.vue?vue&type=template&id=9181d334&scoped=true"
import script from "./DioptraModalProductCard.vue?vue&type=script&lang=js"
export * from "./DioptraModalProductCard.vue?vue&type=script&lang=js"
import style0 from "./DioptraModalProductCard.vue?vue&type=style&index=0&id=9181d334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9181d334",
  null
  
)

export default component.exports